export default "icons-resize-large"